export const WEDDING_DATE_GRANULARITY = {
	EXACT: 'exact',
	SYSTEM_INFERRED: 'system_inferred',
} as const;

export type WeddingDateGranularity =
	(typeof WEDDING_DATE_GRANULARITY)[keyof typeof WEDDING_DATE_GRANULARITY];
